import ApiService from "@/services/api.service";
import logger from "@/utils/logger";

/**
 * Send plain-text company notification email via SendGrid (server reads Settings → Email recipients).
 * Does not throw — failures are logged (same spirit as optional WhatsApp follow-ups).
 * @param {string} message
 * @param {string|number|null|undefined} companyId
 * @param {string} [subject='Anna Books notification']
 * @param {{ event?: string, bannerTitle?: string, html?: string, attachments?: { content: string, filename: string, type?: string }[] }} [emailOptions]
 *   event: Settings → Email checkbox key ('bill' | 'pay-bill' | 'invoice' | 'receive-payment' | 'timesheet' | 'consultant').
 */
export async function sendCompanyNotificationEmail(
  message,
  companyId,
  subject = "Anna Books notification",
  emailOptions = {}
) {
  if (companyId == null || companyId === "") return;
  const text = String(message || "");
  if (!text.trim()) return;

  const payload = {
    message: text,
    companyId: String(companyId),
    subject: String(subject || "Anna Books notification").trim() || "Anna Books notification",
  };
  if (emailOptions?.event) {
    payload.event = String(emailOptions.event).trim();
  }
  const bt = emailOptions?.bannerTitle != null ? String(emailOptions.bannerTitle).trim() : "";
  if (bt) {
    payload.bannerTitle = bt.slice(0, 500);
  }
  const html = emailOptions?.html != null ? String(emailOptions.html).trim() : "";
  if (html) {
    payload.html = html.slice(0, 500000);
  }
  const atts = Array.isArray(emailOptions?.attachments) ? emailOptions.attachments : [];
  const normalizedAttachments = atts
    .slice(0, 3)
    .map((a) => ({
      content: String(a?.content || "")
        .trim()
        .replace(/\s/g, ""),
      filename: String(a?.filename || "attachment")
        .trim()
        .slice(0, 200),
      ...(a?.type ? { type: String(a.type).trim().slice(0, 120) } : {}),
    }))
    .filter((a) => a.content && a.filename);
  if (normalizedAttachments.length > 0) {
    payload.attachments = normalizedAttachments;
  }

  try {
    const response = await ApiService.post("/system/company-notification-email", payload);
    if (response.data?.skipped) {
      logger.log("Company email notification skipped:", response.data.reason || "skipped");
    } else {
      logger.log("Company email notification sent:", response.data);
    }
  } catch (err) {
    logger.error("Failed to send company notification email:", {
      message: err?.message,
      status: err?.response?.status,
      data: err?.response?.data,
    });
  }
}
